import { defineStore } from "pinia";
import { ref, computed } from "vue";
import {
  CONCERTS_STYLES,
  getEventLogoSrc,
  normalizeConcertsStyle
} from "../constants/concertsStyles";
import { useThemeStore } from "./theme";
import alternateStyleUrl from "../assets/styles/concerts-style-wise.css?url";

const ALTERNATE_STYLESHEET_ID = "concerts-style-wise";

function loadAlternateStylesheet() {
  if (document.getElementById(ALTERNATE_STYLESHEET_ID)) return;

  const link = document.createElement("link");
  link.id = ALTERNATE_STYLESHEET_ID;
  link.rel = "stylesheet";
  link.href = alternateStyleUrl;
  document.head.appendChild(link);
}

function unloadAlternateStylesheet() {
  document.getElementById(ALTERNATE_STYLESHEET_ID)?.remove();
}

export const useConcertsStyleStore = defineStore("concertsStyle", () => {
  const styleKey = ref(CONCERTS_STYLES.DEFAULT);
  const themeBeforeWise = ref(null);

  const isWise = computed(() => styleKey.value === CONCERTS_STYLES.WISE);

  const applyEventStyle = (concertsStyle) => {
    const themeStore = useThemeStore();
    const normalized = normalizeConcertsStyle(concertsStyle);
    const wasWise = styleKey.value === CONCERTS_STYLES.WISE;

    styleKey.value = normalized;
    document.documentElement.dataset.concertsStyle = styleKey.value;

    if (normalized === CONCERTS_STYLES.WISE) {
      if (!wasWise) {
        themeBeforeWise.value = themeStore.isDark;
      }
      loadAlternateStylesheet();
      themeStore.setEventTheme("dark");
    } else {
      unloadAlternateStylesheet();
      if (wasWise && themeBeforeWise.value !== null) {
        themeStore.setEventTheme(themeBeforeWise.value ? "dark" : "light");
        themeBeforeWise.value = null;
      }
    }
  };

  const resetToDefault = () => {
    applyEventStyle(CONCERTS_STYLES.DEFAULT);
  };

  const rankBadgeClass = (rank) => `cs-rank-badge cs-rank-badge-${Math.min(rank, 4)}`;

  const rankCardClass = (rank) => `cs-rank-card cs-rank-card-${Math.min(rank, 4)}`;

  const ledRankBadgeClass = (index) => rankBadgeClass(index);

  const logoSrc = (isDark) => getEventLogoSrc(styleKey.value, isDark);

  return {
    styleKey,
    isWise,
    applyEventStyle,
    resetToDefault,
    rankBadgeClass,
    rankCardClass,
    ledRankBadgeClass,
    logoSrc
  };
});
